import styled from 'styled-components';

export const LogoWrapper = styled.div`
  position: relative;
`;

export const AboutLogo = styled.img`
  margin-left: 20%;
  margin-top: -86px;
  width: 150px;
  height: 150px;
  border-radius: 5px;
  box-shadow: 1px 1px 3px #4b4b4b;
`;

export const Strong = styled.strong`
  font-weight: 900;
  font-size: 18px;
  color: #4b4b4b;
`;

export const IntroParagraph = styled.p`
  line-height: 28px;
  color: #898989;
`;

export const InfoList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const InfoItem = styled.li`
  margin-bottom: 8px;
  color: #4b4b4b;
`;

export const InfoLink = styled.a`
  color: #12a5e1;
`;

export const PhotoCaption = styled.p`
  text-align: center;
`;
